import styled from 'styled-components';
export var StyledGlobalFont = styled.div.withConfig({
  displayName: "Themestyle__StyledGlobalFont",
  componentId: "sc-1cw5fma-0"
})(["font-family:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.font.family.primary;
});